/* eslint-disable prefer-regex-literals */
/* eslint-disable no-bitwise */
/* eslint-disable prefer-template */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */

function is8Prime(n) {
  if (n === 0 || n === 1) { return false; }
  for (let i = 2; i * i <= n; i++) { if (n % i === 0) return false; }

  return true;
}

export const question1 = {
  name: 'something',
  difficulty: 'easy',
  fn: (input) => {
    if (input > 134218000) return 'Too large input';
    if (isNaN(input) || input <= 0) { return 'Invalid Input'; }
    let sum = 0;
    for (let i = 1; i <= input; i++) { sum += i; }
    return sum;
  },
};

export const question2 = {
  name: 'something',
  difficulty: 'easy',
  fn: (input) => {
    if (isNaN(input) || input <= 0) { return 'Invalid Input'; }
    let n1 = 0;
    let n2 = 1;
    let nextTerm;
    const fibo = [];
    for (let i = 1; i <= input; i++) {
      fibo.push(n1);
      nextTerm = n1 + n2;
      n1 = n2;
      n2 = nextTerm;
    }
    return fibo;
  },
};

export const question3 = {
  name: 'something',
  difficulty: 'easy',
  fn: (input) => {
    if (isNaN(input) || input < 0) { return 'Invalid Input'; }
    let sum = input >= 2 ? 2 : 0;
    for (let i = 3; i <= input; i += 2) {
      let isPrime = true;
      for (let j = 3; j < (i / 2); j++) {
        if (i % j === 0) {
          isPrime = false;
          break;
        }
      }
      sum += isPrime ? i : 0;
    }
    return sum;
  },
};

export const question4 = {
  name: 'something',
  difficulty: 'medium',
  fn: (input) => ('0' + (Number(input).toString(16))).slice(1).toUpperCase(),
};

export const question5 = {
  name: 'something',
  difficulty: 'medium',
  fn: (input) => {
    if (isNaN(input) || input < 0) { return 'Invalid Input'; }
    let count = 0;
    let number = input;
    while (number) {
      count += number & 1;
      number >>= 1;
    }
    return count;
  },
};

export const question6 = {
  name: 'something',
  difficulty: 'medium',
  fn: (input) => {
    const pat = new RegExp(/[^0-9]/);
    if (pat.test(input)) return 'Please enter a valid integer';
    const len = input.length;
    const mid = Math.floor(len / 2);

    for (let i = 0; i < mid; i++) {
      if (input[i] !== input[len - 1 - i]) {
        return false;
      }
    }
    return true;
  },
};

export const question7 = {
  name: 'something',
  difficulty: 'difficult',
  fn: (input) => {
    const pat = new RegExp(/[^0-9]/);
    if (pat.test(input)) return 'Please enter a valid integer';

    function countFactor(P, X) {
      if (X < P) return 0;
      return (parseInt(X / P, 10) + countFactor(P, parseInt(X / P, 10)));
    }

    let low = 0;
    let high = 5 * input;
    let N = 0;

    while (low <= high) {
      const mid = parseInt((high + low) / 2, 10);

      if (countFactor(5, mid) < input) {
        low = mid + 1;
      } else {
        N = mid;
        high = mid - 1;
      }
    }
    return N;
  },
};

export const question8 = {
  name: 'something',
  difficulty: 'difficult',
  fn: (str) => {
    let sum = 0;
    const n = str.length;
    // For every character
    for (let i = 0; i < n; i++) {
      // If current position is prime
      // then add the ASCII value of the
      // character at the current position
      if (is8Prime(i + 1)) {
        sum += str.charCodeAt(i);
      }
    }

    return sum;

    //     const sieve = [];
    //     let i;
    //     let j;
    //     const primes = [];
    //     for (i = 2; i <= max; ++i) {
    //       if (!sieve[i]) {
    //         primes.push(i);
    //         for (j = i << 1; j <= max; j += i) {
    //           sieve[j] = !0;
    //         }
    //       }
    //     }
    //     return primes;
    //   }
    //   const pat = new RegExp(/\s|[^a-zA-Z]/);
    //   if (pat.test(data)) return 'String cannot contain non alphabet characters';
    //   data = data.replace(/[^a-zA-Z]/g, '');
    //   const primeNumbers = getPrimes(data.length);
    //   let returnSum = 0;
    //   for (let i = 0; i < data.length; i++) {
    //     if (primeNumbers.includes(i)) {
    //       returnSum += data[i].charCodeAt();
    //     }
    //   }
    //   return returnSum;
    // },}
  },
};

export const question9 = {
  name: 'something',
  difficulty: 'difficult',
  fn: (input) => {
    const pat = new RegExp(/[^0-9]/);
    if (pat.test(input)) return 'Please enter a valid integer';
    if (Number(input) > 10000000) return 'Please enter a valid integer less than 10000000';
    const sieve = [];
    let i;
    let j;
    let count = 0;
    for (i = 2; i <= input; ++i) {
      if (!sieve[i]) {
        count += 1;
        for (j = i << 1; j <= input; j += i) {
          sieve[j] = !0;
        }
      }
    }
    return count;
  },
};

export default [question1, question2, question3, question4,
  question5, question6, question7, question8, question9];
